(() => {
  if (customElements.get('kd-hp-trustpilot')) return;
  const counts = new Map();
  customElements.define('kd-hp-trustpilot', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const {signal} = this.controller;
      this.track = this.querySelector('[data-track]');
      this.cards = [...this.querySelectorAll('[data-review-category]')];
      this.filters = [...this.querySelectorAll('[data-category]')];
      this.dots = this.querySelector('[data-dots]');
      this.controls = this.querySelector('[data-controls]');
      this.active = 'quality';
      this.page = 0;
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.dataset.category) this.filter(button.dataset.category);
        else if (button.dataset.page != null) this.go(Number(button.dataset.page));
        else if (button.dataset.step) this.go(this.page + Number(button.dataset.step));
      }, {signal});
      this.track.addEventListener('scroll', () => {
        const positions = this.positions();
        if (!positions.length) return;
        this.page = positions.reduce((best, pos, index) => Math.abs(pos - this.track.scrollLeft) < Math.abs(positions[best] - this.track.scrollLeft) ? index : best, 0);
        this.updateDots();
      }, {signal, passive: true});
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('[data-review-category]');
        if (!card) return;
        this.filter(card.dataset.reviewCategory);
        this.go(Math.floor(this.visible.indexOf(card) / this.perPage), false);
      }, {signal});
      this.filter(this.active);
      this.resize = new ResizeObserver(() => {
        const perPage = this.pageSize();
        if (perPage !== this.perPage) {
          this.buildPages();
          this.go(0, false);
        }
      });
      this.resize.observe(this.track);
      this.loadCount();
    }
    pageSize() {
      return matchMedia('(max-width: 749px)').matches ? 1 : 3;
    }
    filter(category) {
      this.active = category;
      this.filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.category === category)));
      this.cards.forEach(card => { card.hidden = card.dataset.reviewCategory !== category; });
      this.visible = this.cards.filter(card => !card.hidden);
      this.querySelector('[data-empty]').hidden = this.visible.length > 0;
      this.buildPages();
      this.go(0, false);
    }
    buildPages() {
      this.perPage = this.pageSize();
      this.totalPages = Math.ceil(this.visible.length / this.perPage);
      this.dots.replaceChildren();
      for (let index = 0; index < this.totalPages; index++) {
        const dot = document.createElement('button');
        dot.type = 'button'; dot.className = 'kd-hpt__dot'; dot.dataset.page = index;
        dot.setAttribute('aria-label', `${this.dataset.pageLabel} ${index + 1}`);
        dot.append(document.createElement('span')); this.dots.append(dot);
      }
      this.controls.hidden = this.totalPages <= 1;
    }
    positions() {
      const left = this.track.getBoundingClientRect().left;
      return Array.from({length: this.totalPages}, (_, page) => {
        const index = Math.min(page * this.perPage, Math.max(0, this.visible.length - this.perPage));
        return this.visible[index].getBoundingClientRect().left - left + this.track.scrollLeft;
      });
    }
    go(page, animate = true) {
      if (!this.totalPages) { this.track.scrollLeft = 0; return; }
      this.page = (page + this.totalPages) % this.totalPages;
      this.track.scrollTo({left:this.positions()[this.page], behavior:animate ? 'smooth' : 'auto'});
      this.updateDots();
    }
    updateDots() {
      [...this.dots.children].forEach((dot, index) => {
        if (index === this.page) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }
    loadCount() {
      if (!this.dataset.apiKey || !this.dataset.businessUnit) return;
      const url = `https://api.trustpilot.com/v1/business-units/${encodeURIComponent(this.dataset.businessUnit)}?apikey=${encodeURIComponent(this.dataset.apiKey)}`;
      if (!counts.has(url)) counts.set(url, fetch(url).then(r => r.ok ? r.json() : null).catch(() => null));
      counts.get(url).then(data => {
        const count = data?.numberOfReviews?.total;
        if (this.isConnected && Number.isInteger(count) && count >= 0) this.querySelector('[data-review-count]').textContent = count.toLocaleString('en-GB');
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resize?.disconnect();
      this.controller = null;
    }
  });
})();
